import { escapeHtml, flipCardHtml, readFlipCard, replaceWidgetNode } from './markup';
import { dialogStyles as s, openFormDialog } from './dialogHelpers';

export const openFlipCardDialog = (editorInstance, existingNode = null) => {
  const values = existingNode ? readFlipCard(existingNode) : { front: '', back: '' };

  openFormDialog(editorInstance, {
    title: existingNode ? 'Edit flip card' : 'Insert flip card',
    submitLabel: existingNode ? 'Update' : 'Insert',
    minWidth: 560,
    errorMessage: 'Add text on the front or back of the card.',
    html: `<p class="${s.hint}">Learners tap the card to flip between the front and back. Use a term on the front and the answer on the back.</p>
      <div class="${s.pair}">
        <label class="${s.field}"><span>Front</span>
          <textarea class="jodit-input mc-flip-front" rows="4" placeholder="Term or question">${escapeHtml(
            values.front,
          )}</textarea>
        </label>
        <label class="${s.field}"><span>Back</span>
          <textarea class="jodit-input mc-flip-back" rows="4" placeholder="Definition or answer">${escapeHtml(
            values.back,
          )}</textarea>
        </label>
      </div>`,
    onSubmit: (form) => {
      const front = form.querySelector('.mc-flip-front')?.value.trim() || '';
      const back = form.querySelector('.mc-flip-back')?.value.trim() || '';
      if (!front && !back) {
        return false;
      }
      replaceWidgetNode(editorInstance, existingNode, flipCardHtml({ front, back }));
      return true;
    },
  });
};

export const getFlipCardButton = () => ({
  name: 'mcFlipCard',
  tooltip: 'Flip card',
  exec: (editorInstance) => openFlipCardDialog(editorInstance),
});
